class QuickBuy extends HTMLElement {
  connectedCallback () {
    this.button = this.querySelector('[data-quick-buy-btn]')
    this.buttonText = this.querySelector('[data-quick-buy-btn] span')
    this.buttonLoader = this.querySelector('.loading-overlay__spinner')
    this.cartItems = document.querySelector('cart-items')
    this.fostrVariantRadios = this.querySelector('fostr-variant-radios')
    this.variantIds = this.getAttribute('variant-ids')
    this.properties = this.getAttribute('line-item-props')
    this.addOnChange = this.getAttribute('add-on-change') === 'true'
    this.error = this.querySelector('.product-quickbuy__error-message-wrapper')
    this.errorMessageText = this.querySelector(
      '.product-quickbuy__error-message',
    )
    this.errorMessageWrapper = this.querySelector(
      '.product-quickbuy__error-message-wrapper',
    )
    this.allowedValues = ['color', 'colour']
    this.colourName = this.querySelector(
      '.product-connections .form__label span',
    )
    this.colourGroup = this.querySelector('other-colours')
    this.quickBuyClose = this.querySelector('.quickbuy__close')

    this.mobileTrigger = document.querySelector(
      `[data-trigger="quickbuyitem-${this.fostrVariantRadios.dataset.section}"]`,
    )

    this.mobileTarget = document.querySelector(
      `[data-target="quickbuyitem-${this.fostrVariantRadios.dataset.section}"]`,
    )

    this.wishlistATCButton = this.parentNode.querySelector(
      `.quick-buy-wishlist[data-trigger="quickbuyitem-${this.fostrVariantRadios.dataset.section}"]`,
    )

    if (!this.button) {
      return
    }

    this.button.addEventListener('click', this.addToCart.bind(this))
    this.wishlistATCButton?.addEventListener('click', this.addToCart.bind(this))
    this.addEventListener('change', this.onVariantChange.bind(this))

    this.mobileTrigger?.addEventListener(
      'click',
      this.onClickHandlerMobileTrigger.bind(this),
    )

    this.quickBuyClose.addEventListener(
      'click',
      this.onClickHandlerMobileTrigger.bind(this),
    )

    if (this.colourGroup) {
      const colourGroupItems = Array.from(
        this.colourGroup.querySelectorAll('a.colour'),
      )
      colourGroupItems.forEach(colour => {
        colour.addEventListener(
          'click',
          this.onClickHandlerGroupColor.bind(this),
        )
      })
    }
  }

  onClickHandlerMobileTrigger () {
    if (window.innerWidth <= 749) {
      document
        .getElementById('ProductGridContainer')
        .querySelector('.collection')
        .classList.toggle('loading')
      this.mobileTarget.classList.toggle('open')
    }
  }

  onVariantChange (event) {
    if (event) {
      if (event.target.classList.contains('disabled')) {
        event?.preventDefault()
        this.outOfStock = true
        const variantUrl = `${event.target.dataset.productBackinstockUrl}?variant=${this.variantIds}`
        window.location.href = variantUrl
        return
      }
    }

    this.classList.add('loading')
    this.querySelector('.loading-overlay.product-loading')?.classList.remove(
      'hidden',
    )

    if (this.addOnChange) {
      this.addToCart(event)
    }
  }

  onProductChange () {
    this.updateOptions()
    this.handleErrorMessage()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.updateVariantInput()
      this.toggleAddButton(
        !this.currentVariant.available,
        window.variantStrings.soldOut,
      )
    }
  }

  updateOptions () {
    const fieldsets = Array.from(
      this.fostrVariantRadios.querySelectorAll('fieldset'),
    )
    this.options = fieldsets.map(fieldset => {
      const inputs = fieldset.querySelectorAll('input')
      let colourElement = Array.from(inputs).find(radio => radio.checked)
      if (!colourElement) {
        colourElement = Array.from(inputs).find(radio => radio.defaultChecked)
      }
      if (!colourElement) {
        colourElement = Array.from(inputs)[0]
      }
      if (
        this.allowedValues.includes(
          colourElement.name
            .split('-')
            .reverse()[0]
            .toLowerCase(),
        )
      ) {
        this.colourName.innerHTML = colourElement.value
      }
      return colourElement.value
    })
  }

  updateVariantInput () {
    this.setAttribute('variant-ids', this.currentVariant.id)
    this.variantIds = this.getAttribute('variant-ids')
  }

  getVariantData () {
    this.variantData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent,
    )
    return this.variantData
  }

  updateMedia (productImage = false) {
    let currentFeature = ''

    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) {
      if (productImage) {
        currentFeature = productImage
      } else {
        return
      }
    } else {
      currentFeature = this.currentVariant.featured_media.preview_image.src
    }

    const imgSizes = ['165', '360', '533', '720', '940', '1066']
    const format = `.${currentFeature.split('.').reverse()[0]}`
    const itemMedia = document.querySelector(
      `[data-media-id="${this.fostrVariantRadios.dataset.section}"]`,
    )

    let srcSizes = ''
    const newFormat = `_${imgSizes[2]}x${format}`
    const srcImg = currentFeature.replace(format, newFormat)

    imgSizes.forEach((size) => {
      const newFormat = `_${size}x${format} ${size}w,`
      const newSize = currentFeature.replace(format, newFormat)
      srcSizes = srcSizes + newSize
    })

    itemMedia.src = srcImg
    itemMedia.srcset = srcSizes
  }

  renderProductInfo () {
    fetch(
      `${this.fostrVariantRadios.dataset.url}?variant=${this.currentVariant.id}`,
    )
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')

        const priceId = `.price-${this.fostrVariantRadios.dataset.section}`
        const priceSource = html.querySelector('.price')

        const variantTitleId = `.variant-${this.fostrVariantRadios.dataset.section}`
        const variantTitleSource = this.currentVariant.title

        document.querySelectorAll(priceId).forEach(priceDestination => {
          if (priceSource && priceDestination) {
            priceDestination.innerHTML = priceSource.innerHTML
          }
        })

        document
          .querySelectorAll(variantTitleId)
          .forEach(variantTitleDestination => {
            if (
              variantTitleSource &&
              variantTitleDestination &&
              variantTitleSource !== 'Default Title'
            ) {
              variantTitleDestination.innerHTML = variantTitleSource
            }
          })

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        )
      })
      .finally(() => {
        this.querySelector('.loading-overlay.product-loading')?.classList.add(
          'hidden',
        )
        this.classList.remove('loading')
      })
  }

  toggleAddButton (disable = true, text, modifyClass = true) {
    const addButton = this.button
    const addButtonText = this.buttonText
    if (!addButton) return

    if (disable) {
      addButton.setAttribute('aria-disabled', true)
      this.querySelector('.loading-overlay.product-loading')?.classList.add(
        'hidden',
      )
      this.classList.remove('loading')
      if (text) addButtonText.textContent = text
    } else {
      addButton.removeAttribute('aria-disabled')
      addButtonText.textContent = window.variantStrings.addToCart
    }
  }

  setUnavailable () {
    const addButton = this.button
    const addButtonText = this.buttonText
    const price = document.querySelector(
      `price-${this.fostrVariantRadios.dataset.section}`,
    )
    if (!addButton) return
    addButtonText.textContent = window.variantStrings.unavailable
    if (price) price.classList.add('visibility-hidden')
  }

  handleErrorMessage (errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.error
    this.errorMessage = this.errorMessage || this.errorMessageText
    this.errorMessageWrapper?.toggleAttribute('hidden', !errorMessage)

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage
    }
  }

  addToCart (event) {
    event?.preventDefault()

    if (this.outOfStock) {
      return
    }

    if (!this.variantIds) {
      return
    }

    this.handleErrorMessage()

    event.target.classList.add('loading')

    const quantityEl = this.querySelector('input[name="quantity"]')
    const quantity = quantityEl ? parseInt(quantityEl.value) : 1

    let properties
    if (this.properties) {
      try {
        properties = JSON.parse(this.properties)
      } catch (err) {
        console.error(err)
      }
    }

    const itemsObj = []
    const varIdsArr = event.target.closest('input').getAttribute('data_qb_variant_id').split(',')

    varIdsArr.forEach(varId => {
      itemsObj.push({
        id: varId,
        quantity,
        properties,
      })
    })

    let body = {
      items: itemsObj,
    }

    if (this.cartItems) {
      body.sections = this.cartItems
        .getSectionsToRender()
        .map(section => section.id)
      body.sections_url = window.location.pathname
    }

    body = JSON.stringify(body)

    fetch(`${window.routes.cart_add_url}`, { ...window.fetchConfig('javascript'), body })
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleErrorMessage(response.description)
          return
        }

        const addToCartEvent = new CustomEvent('GA_ADD_TO_CART', {
          detail: {
            formName: 'quickBuy',
            item: response.items[0],
          },
        })
        window.dispatchEvent(addToCartEvent)

        this.cartItems?.renderContents(response)
      })
      .catch(e => {
        console.error(e)
      })
      .finally(() => {
        event.target.classList.remove('loading')
        this.onClickHandlerMobileTrigger()
      })
  }

  groupProductSetup (event) {
    event.preventDefault()

    this.classList.add('loading')
    this.querySelector('.loading-overlay.product-loading')?.classList.remove(
      'hidden',
    )

    const currentItem = this.colourGroup.querySelector('a.colour.current')
    const newItem = event.target
    const newItemUrl = event.target.href

    currentItem.classList.remove('current')
    newItem.classList.add('current')

    this.newDataUrl = this.fostrVariantRadios.getAttribute('data-url')

    if (newItemUrl.includes(this.newDataUrl)) {
      this.querySelector('.loading-overlay.product-loading')?.classList.add(
        'hidden',
      )
      this.classList.remove('loading')
    }
  }

  groupProductSetTitle (html, event) {
    const title = `.title-${this.fostrVariantRadios.dataset.section}`
    const titleSource = html.querySelector('.product__title')
    document.querySelectorAll(title).forEach(titleDestination => {
      if (titleSource && titleDestination) {
        titleDestination.innerHTML = titleSource.innerHTML
        titleDestination.setAttribute('href', event.target.href)
      }
    })
  }

  groupProductSetVariantTitle (html, event) {
    const variantTitleId = `.variant-${this.fostrVariantRadios.dataset.section}`
    const variantTitleSource = this.currentVariant.title
    document
      .querySelectorAll(variantTitleId)
      .forEach(variantTitleDestination => {
        if (
          variantTitleSource &&
          variantTitleDestination &&
          variantTitleSource !== 'Default Title'
        ) {
          variantTitleDestination.innerHTML = variantTitleSource
        }
      })
  }

  groupProductSetPrice (html) {
    const price = `.price-${this.fostrVariantRadios.dataset.section}`
    const priceSource = html.querySelector('.price')

    document.querySelectorAll(price).forEach(priceDestination => {
      if (priceSource && priceDestination) {
        priceDestination.innerHTML = priceSource.innerHTML
        priceDestination.classList.remove('visibility-hidden')
      }
    })
  }

  groupProductSetColour (html) {
    const colour = `.colour-${this.fostrVariantRadios.dataset.section}`
    const colourSource = html.querySelector('.colour_label')
    document.querySelectorAll(colour).forEach(colourDestination => {
      if (colourSource && colourDestination) { colourDestination.innerHTML = colourSource.innerHTML }
    })
  }

  groupProductSetVariantData (html, event) {
    const variantIDSource = html.querySelector(
      '.product-form input[type="hidden"][name="id"]',
    )
    this.fostrVariantRadios.setAttribute('data-url', event.target.href)
    if (variantIDSource) {
      this.setAttribute('variant-ids', variantIDSource.getAttribute('value'))
      this.variantIds = this.getAttribute('variant-ids')
    }
  }

  groupProductSetOptions (html) {
    const variantOptionsDestination = this.fostrVariantRadios
    const variantOptionsSource = html.querySelector('fostr-variant-radios')
    if (variantOptionsSource && variantOptionsDestination) {
      variantOptionsDestination.innerHTML = variantOptionsSource.innerHTML
    }
  }

  groupProductSetMedia (html) {
    this.mediaData = JSON.parse(
      html.querySelector('#product-image-data[type="application/json"]')
        .textContent,
    )
    if (this.mediaData) {
      this.updateMedia(this.mediaData.src)
    }
  }

  onClickHandlerGroupColor (event) {
    this.groupProductSetup(event)
    fetch(`${event.target.href}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        this.groupProductSetTitle(html, event)
        this.groupProductSetPrice(html)
        this.groupProductSetColour(html)
        this.groupProductSetVariantData(html, event)
        this.groupProductSetOptions(html)
        this.onProductChange()
        this.groupProductSetMedia(html)
        this.groupProductSetVariantTitle(html)
      })
      .finally(() => {
        this.querySelector('.loading-overlay.product-loading')?.classList.add(
          'hidden',
        )
        this.classList.remove('loading')
      })
  }
}

customElements.define('quick-buy', QuickBuy)
